<!-- Add manage configuration guard best in the state, or a block with a message here, to be further discussed -->
<ul id="configuration-fields" class="reports-and-notif max-w-900px">
  <li class="configuration-field">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-5">
          <h3>{{ "reports_n_notif" | localize }}</h3>
          <div class="description">
            <p>{{ "set_freq_reports_short" | localize }} {{ accountNotificationsCadenceType }}.</p>
          </div>
        </div>
        <div class="col-md-6 col-md-offset-1 row">
          <a class="gh-b gh-prime" gh-sref="._cadence.cadence">{{ "report_settings" | localize }}</a>
          <a class="gh-b gh-prime mt-20px" gh-sref="._accountNotificationSettings.accountNotificationSettings">{{ "account_notification_settings" | localize }}</a>
        </div>
      </div>
    </div>
  </li>
</ul>
